/* Mobile Category Chips — mouse drag-to-scroll
 *
 * Native touch handles horizontal swipe out of the box. This script adds
 * click-and-drag scrolling for non-touch pointers (mouse, trackpad) so the
 * "draggable to move between all elements" behaviour from the Pencil design
 * works in desktop preview and the Shopify theme editor.
 *
 * The script is idempotent and safe to load multiple times (e.g. when Shopify
 * re-renders a section in the editor).
 */
(function () {
  'use strict';

  var DRAG_THRESHOLD = 4;
  var INIT_FLAG = '__mccDragInit';

  function init(scroller) {
    if (!scroller || scroller[INIT_FLAG]) return;
    scroller[INIT_FLAG] = true;

    var isDown = false;
    var didDrag = false;
    var startX = 0;
    var startScrollLeft = 0;
    var pointerId = null;

    function onPointerDown(event) {
      if (event.pointerType === 'touch') return;
      if (event.button !== undefined && event.button !== 0) return;

      isDown = true;
      didDrag = false;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScrollLeft = scroller.scrollLeft;

      try {
        scroller.setPointerCapture(event.pointerId);
      } catch (_) { /* older browsers — no-op */ }
    }

    function onPointerMove(event) {
      if (!isDown || event.pointerId !== pointerId) return;
      var dx = event.clientX - startX;

      if (!didDrag && Math.abs(dx) > DRAG_THRESHOLD) {
        didDrag = true;
        scroller.classList.add('is-grabbing');
      }

      if (didDrag) {
        event.preventDefault();
        scroller.scrollLeft = startScrollLeft - dx;
      }
    }

    function release(event) {
      if (!isDown) return;
      if (event && pointerId !== null && event.pointerId !== pointerId) return;

      isDown = false;
      try {
        if (pointerId !== null) scroller.releasePointerCapture(pointerId);
      } catch (_) { /* no-op */ }
      pointerId = null;
      scroller.classList.remove('is-grabbing');
    }

    function onClickCapture(event) {
      if (didDrag) {
        event.preventDefault();
        event.stopPropagation();
        didDrag = false;
      }
    }

    scroller.addEventListener('pointerdown', onPointerDown);
    scroller.addEventListener('pointermove', onPointerMove);
    scroller.addEventListener('pointerup', release);
    scroller.addEventListener('pointercancel', release);
    scroller.addEventListener('pointerleave', release);
    scroller.addEventListener('click', onClickCapture, true);
  }

  function initAll(root) {
    var ctx = root || document;
    var nodes = ctx.querySelectorAll('[data-mcc-scroller]');
    for (var i = 0; i < nodes.length; i++) {
      init(nodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
